export default "__VITE_ASSET__D0Oi0PP6__"